<template>
  <!-- Table -->
  <DataView ref="dataViewRef" v-bind="tableConfigRef">
    <template #header__center>
      <Button
        class="order-categories hidden md:flex"
        icon="pi pi-arrows-v"
        label="Ordenar categorías"
        @click="showOrderCategoriesDialog()"
        :loading="loading"
        loading-icon="pi pi-spinner"
      />
    </template>

    <!-- descripcion column -->
    <template #table__descripcion__body="{ data }">
      <div class="long-text-column">
        {{ data.descripcion }}
      </div>
    </template>
    <template #list__descripcion="{ data }">
      <div class="long-text-column">
        {{ data.descripcion }}
      </div>
    </template>

    <!-- descripcion column -->
    <template #table__creadaPor__body="{ data }">
      <div v-if="data.creadaPor" class="long-text-column">
        {{ data.creadaPor }}
      </div>
      <div v-else class="text-gray-400">-</div>
    </template>
    <template #list__creadaPor="{ data }">
      <div v-if="data.creadaPor" class="long-text-column">
        {{ data.creadaPor }}
      </div>
      <div v-else class="text-gray-400">-</div>
    </template>

    <!-- fechaCreacion column -->
    <template #table__fechaCreacion__body="{ data }">
      {{ formatDate(convertUtcToLocalTime(data.fechaCreacion)) }}
      {{ formatTime(convertUtcToLocalTime(data.fechaCreacion)) }}
    </template>
    <template #list__fechaCreacion="{ data }">
      {{ formatDate(convertUtcToLocalTime(data.fechaCreacion)) }}
      {{ formatTime(convertUtcToLocalTime(data.fechaCreacion)) }}
    </template>
  </DataView>

  <!-- Modal -->
  <CategoriesDialogView ref="modalRef" @saved="updateTableList" />

  <!-- Order categories modal -->
  <OrderCategoriesDialogView
    ref="orderCategoriesModalRef"
    @saved="updateTableList"
  />
</template>

<script setup>
import { ref } from "vue";
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
import Button from "primevue/button";
import { DataView, useImmer } from "@sttedra_ui/framework";

import useTableConfig from "@/pages/_root/categories/categories-table.view-config.js";
import CategoriesDialogView from "@/pages/_root/categories-dialog/CategoriesDialogView.vue";
import OrderCategoriesDialogView from "@/pages/_root/order-categories-dialog/OrderCategoriesDialogView.vue"; // eslint-disable-line
import { categoriesDelete } from "@/api/categories/categories.api.js";
import {
  formatDate,
  formatTime,
  convertUtcToLocalTime,
} from "@/composables/_commons/helper.js";

// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const confirm = useConfirm();
const toast = useToast();
const orderCategoriesModalRef = ref(null);
const modalRef = ref(null);
const dataViewRef = ref(null);
const tableConfig = new useTableConfig(buildModal, deleteRegister);
const { ref: tableConfigRef } = useImmer(tableConfig);
const loading = ref(false);
// #endregion

// #region Functions
function buildModal(event = null) {
  modalRef.value.showModal(event ? event.data : null);
}

function deleteRegister({ data }) {
  confirm.require({
    message: "¿Desea borrar el registro?",
    header: "Borrar",
    icon: "pi pi-exclamation-triangle",
    rejectClass: "p-button-secondary p-button-outlined",
    accept: async () => {
      const response = await categoriesDelete(data.aliasCategoria);

      if (response.status == 200) {
        toast.add({
          severity: "success",
          summary: "Registro borrado",
          detail: `Se ha borrado el registro correctamente`,
          life: 3000,
        });

        updateTableList();
      } else {
        toast.add({
          severity: "error",
          summary: "Error",
          detail: "Ha ocurrido un error al borrar el registro",
          life: 3000,
        });
      }
    },
  });
}

function updateTableList() {
  dataViewRef.value.debounceRefreshAndUpdate();
}

async function showOrderCategoriesDialog() {
  loading.value = true;
  await orderCategoriesModalRef.value.showModal();
  loading.value = false;
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
// #endregion
</script>

<style lang="scss" scoped>
.order-categories {
  padding: 0.75rem;
  max-height: 2.5rem;

  :deep(.p-button-label) {
    font-weight: normal;
  }
}
</style>
